export default __webpack_public_path__ + "static/value-vs-cost-39e6424fb7a67884b6954bc321e99dfa.jpg";